export default __webpack_public_path__ + "static/media/madeWithThunkNotes_darkmode.b791e6a5.svg";